import React from "react";
import postDoc from "../../../services/Documents/postDoc";
import { Upload, X } from "lucide-react";

export const UploadPdfModal = ({
  setPdf,
  setAddStatus,
  setPdfName,
  closeAddModal,
  pdf,
  pdfName,
  updateTreeBranch,
  addStatus,
  userId,
  parentFolderId,
  caseId = null
}) => {
  const handlePdfFileChange = (e) => {
    if (e.target.files[0]) {
      setPdf(e.target.files[0]);
      setAddStatus("");
      // Auto-populate the name field with the file name (without extension)
      const fileName = e.target.files[0].name;
      const nameWithoutExtension = fileName.replace(/\.[^/.]+$/, "");
      setPdfName(nameWithoutExtension);
    }
  };

  const handlePdfNameChange = (e) => {
    setPdfName(e.target.value);
  };

  const handleAddPdf = async (e) => {
    e.preventDefault();

    if (!pdf) {
      setAddStatus("Please select a PDF file");
      return;
    }

    if (!pdfName.trim()) {
      setAddStatus("Please enter a name for the document");
      return;
    }

    try {
      setAddStatus("Uploading document...");

      const formData = new FormData();
      formData.append("pdf", pdf);
      formData.append("name", pdfName);
      if(parentFolderId !== null) formData.append("parentFolderId", parentFolderId);
      if(caseId !== null) formData.append("caseId", caseId);

      const uploadPdfResponse = await postDoc(userId, formData);

      if (uploadPdfResponse) {
        setAddStatus("Document uploaded successfully");

        // Refresh the documents list after successful upload
        setTimeout(async () => {
          updateTreeBranch();
          closeAddModal();
        }, 1500);
      } else {
        setAddStatus("Failed to upload document");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      setAddStatus("An error occurred while uploading the document");
    }
    console.log("Uploading document...");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
        <button
          onClick={closeAddModal}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>

        <h3 className="text-xl font-bold mb-4">Añadir un documento</h3>

        <form onSubmit={handleAddPdf}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              PDF File
            </label>
            <div className="flex items-center">
              <input
                type="file"
                accept=".pdf"
                onChange={handlePdfFileChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            {pdf && (
              <p className="mt-1 text-sm text-gray-500">
                Selected: {pdf.name} ({Math.round(pdf.size / 1024)} KB)
              </p>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Document Name
            </label>
            <input
              type="text"
              value={pdfName}
              onChange={handlePdfNameChange}
              placeholder="Enter a name for this document"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 px-4 bg-green-600 hover:bg-green-700 text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 flex items-center justify-center"
          >
            <Upload size={18} className="mr-2" />
            Upload Document
          </button>
        </form>

        {addStatus && (
          <div
            className={`mt-4 p-3 rounded-md ${
              addStatus.includes("successfully")
                ? "bg-green-100 text-green-800"
                : addStatus.includes("Failed") ||
                  addStatus.includes("Please") ||
                  addStatus.includes("error")
                ? "bg-red-100 text-red-800"
                : "bg-blue-100 text-blue-800"
            }`}
          >
            {addStatus}
          </div>
        )}
      </div>
    </div>
  );
};
